module.exports = __webpack_public_path__ + "2f3f1b1d14a5a631df3897a1f69747d2.png";